import React, { useState, useEffect } from "react";

import { useAuth } from "../contexts/AuthContext";
import { useModal } from "../contexts/ModalContext";

import { db } from "../firebase";
import { getDocs, collection, query, limit } from "firebase/firestore";

import Import from "./Import";
import FileImport from "./FileImport";
import Report from "./Report";

import Modal from "./Modal";
import Loading from "./Loading";

export const FileContext = React.createContext();

export default function Dashboard() {
  const { currentUser } = useAuth();
  const { modalState } = useModal();

  const [IsSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [reportExists, setReportExists] = useState(false);
  const [reportData, setReportData] = useState({});
  const [progressData, setProgressData] = useState({});

  const [loading, setLoading] = useState(true);
  const [change, setChange] = useState(false);

  const q = query(collection(db, `users/${currentUser.uid}/bias_reports/`), limit(1));

  useEffect(() => {
    setLoading(true);
    try {
      getDocs(q)
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
              let docSnapData = { disposition_effect: "N/A", overconfidence: "N/A" };
              docSnapData.disposition_effect =
                doc.data().disposition_effect.overall.disposition_effect;
              docSnapData.overconfidence = doc.data().overconfidence.overall.overconfidence;
              setReportExists(true);
              setReportData(docSnapData);
              setProgressData(doc.data());
            });
            setLoading(false);
          } else {
            setReportExists(false);
            setLoading(false);
          }
        })
        .catch(() => {
          setReportExists(false);
          setLoading(false);
        });
    } catch {
      setReportExists(false);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [change]);

  return (
    <>
      <FileContext.Provider
        value={{
          selectedFile,
          setSelectedFile,
          setIsSelected,
          setReportExists,
          reportData,
          setReportData,
          progressData,
          setProgressData,
          loading,
          setLoading,
          change,
          setChange,
        }}
      >
        <div className="section-container dash-section flex-column">
          {modalState.showModal && <Modal />}
          {!reportExists && !loading && <Import />}
          {!loading && reportExists && <Report />}
          {IsSelected && <FileImport />}
          {loading && <Loading />}
        </div>
      </FileContext.Provider>
    </>
  );
}
